import {useEffect, useState, useRef} from 'react';
import {useRouter} from 'next/router';
import {PageHeader, Button, Modal, Spin, Tooltip} from 'antd';
import {PAGES_API} from '@/api/content-optimizer';
// import {BaseApi} from '@/api/base-api';
// import {getApiUrl, getTokenFromCookies} from '@/api/common-utils';
import {GoogleOutlined, LoadingOutlined} from '@ant-design/icons';
import {TitleEditor} from '../title-editor';
import DeleteModal from '@/components/dashboard/pages/landing-page-optimizer/blocks/delete-modal';
import classNames from 'classnames';
import {observer} from 'mobx-react-lite';

import {useStore} from '@/store/root-store';
import styles from './index.module.scss';
import {useTranslation} from 'next-i18next';
import {routes} from '@/utils/const';
import {
  CommonInput, Button as Btn,
} from '@/components/common-components/components/index';
import {Form} from 'antd';
import isURL from 'validator/lib/isURL';
import ButtonComponent from '@/components/common-components/components/button-component';
import {faArrowLeft, faEllipsisV, faFileArrowDown, faShareNodes} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {MixPanel} from '@/utils/mixpanel';
import {SCA_CREATE_PAGE, SCA_PAGE_EXPORT_TO_DOCS} from '@/constants/events';
import {isNil} from 'lodash';
import {Checkbox, GrayButton} from '@/components/common-components/v2';
import {CONTENT_ASSISTANT_API} from '@/api/ContentAssistant';
import styled from 'styled-components';
import {faCheck} from '@fortawesome/pro-regular-svg-icons';
import {notification} from '@/utils/notification';

const useClickedOnPageHandler = (ref, callback) => {
  useEffect(() => {
    const handleClickOutside = event => {
      event.stopPropagation();

      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
};


export const BreadCrumb = observer(() => {
  const router = useRouter();
  const [isKebabOpen, setIsKebabOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [exportToDocsLoading, setExportToDocsLoading] = useState(false);
  const {t} = useTranslation('common');
  const [form] = Form.useForm<{ url: string }>();
  const dropdownRef = useRef(null);
  const headerTopRef = useRef(null);
  const antIcon = <LoadingOutlined style={{fontSize: 12, marginBottom: 12, marginRight: 2, color: '#2d6cca'}} spin />;
  const briefAntIcon = <LoadingOutlined style={{fontSize: 12, marginRight: 4, color: '#2d6cca'}} spin />;

  const [copySuccess, setCopySuccess] = useState(false);


  const {
    contentOptimizer: {
      currentPage: {shareDialog, isEditorScrolled, editorHeightOffset, setEditorHeightOffset, isPublic, content, clearFeTargetKeywords, clearAnalytics, isExporting, uploadFromUrl, updateContentLoadedAt, setCurrentStep, isSaving, exportToGoogledoc, newPage, isExportingPage},
      pages: {deleteDialog, incrementInTotalArticle, setPageRemovedFromEditor},
    },
    settings: {customer: {profile: {isWhitelabel, quotaUtilization, isAllowedPagesQuotaLimitReached}}},
    plans: {showSidebarPaymentDrawer}} = useStore('');
  const {settings: {customer: {isGHLAccount}}} = useStore('');

  useEffect(() => {
    if (!isNil(headerTopRef?.current?.clientHeight)) {
      setEditorHeightOffset(headerTopRef?.current?.clientHeight || 0, editorHeightOffset.keywordsHeight);
    }
  }, [headerTopRef?.current?.clientHeight]);

  useClickedOnPageHandler(dropdownRef, () => {
    setIsKebabOpen(false);
  });

  const createPage = async () => {
    try {
      const {uuid} = await PAGES_API.createPage();

      MixPanel.track(SCA_CREATE_PAGE, {
        'pageId': uuid,
      });

      router.push(`/${routes.landingPageOptimizer}/${uuid}?newPage=true`);
      incrementInTotalArticle();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  const onUploadHandler = async (url: string, renderWithbrowser?: boolean) => {
    try {
      await uploadFromUrl(url, true, renderWithbrowser);
      updateContentLoadedAt();
    } catch (e) {
      setCurrentStep(2);
      throw e;
    } finally {
      setCurrentStep(2);
    }
  };

  const handleSubmit = (value: { url: string; renderWithbrowser: boolean}) => {
    onUploadHandler(value.url, value.renderWithbrowser);
    setIsModalOpen(false);
    setIsKebabOpen(false);
  };

  // const handleExportAll = () => {
  //
  //   MixPanel.track(PRUNING_PAGE_EXPORT_ALL, {
  //     'export': 'pruning page all sections',
  //   });
  //
  //   gscExport.exportSingleNode(allRef.current);
  // };

  // KEPT IN CASE WE NEED IT AGAIN
  // const exportSingleNode = node => {
  //   const today = new Date();
  //   const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  //   html2canvas(node)
  //     .then(canvas => {
  //       canvas.style.display = 'none';
  //       const image = canvas.toDataURL();
  //       const a = document.createElement('a');
  //       a.setAttribute('download', `${content?.title || 'Page'}-export-${date}.png`);
  //       a.setAttribute('href', image);
  //       a.click();
  //       setTimeout(() => {
  //         setIsExportingPageLoader(false);
  //       }, 500);
  //     }).catch(() => {
  //       setTimeout(() => {
  //         setIsExportingPageLoader(false);
  //       }, 1000);
  //     });
  // };


  // const handleExportAll = () => {
  //   exportSingleNode(customRef);
  // };

  // const onExportEntirePage = () => {
  //   setIsExportingPageLoader(true);
  //   setIsExportingPage(true);
  //   setTimeout(() => {
  //     handleExportAll();
  //   }, 500);
  //   // Using local state to handle loading cause exporting is async
  //   setTimeout(() => {
  //     setIsExportingPage(false);
  //   }, 1000);
  // };

  // const getXlsExportLink = () => {
  //   const token = getTokenFromCookies();
  //   if (content?.uuid) {
  //     const baseUrl = getApiUrl(BaseApi.CA_ENDPOINT, `/api/pages/${content?.uuid}/export-data-to-xls/`);
  //     const savedKeywordsUrl = `${baseUrl}?&jwt=${token}`;
  //     return savedKeywordsUrl;
  //   }
  // };

  const exportToGoogleDocs = async () => {
    if (exportToDocsLoading) return;

    setExportToDocsLoading(true);
    const response = await CONTENT_ASSISTANT_API.exportPageToGoogleDocs(content?.uuid);
    if (response) {
      window.open(response, '_blank');
    }
    setExportToDocsLoading(false);
  };

  return (
    <div className={classNames(styles.contentOptimizerContainer, isEditorScrolled && styles.scrolledEditor)} ref={headerTopRef}>
      {/* <MiniBanners variant='light' type='warning' text='This page is under maintenance. You may experience decreased performance or bugs.'/> */}
      <PageHeader
        title={<TitleEditor />}
        className={classNames(styles.contentOptimizerHeader, isEditorScrolled && styles.scrolledEditor)}
        onBack={() => {
          router.push(isPublic ? `/${routes.login}` : `/${routes.landingPageOptimizer}`);
        }}
        backIcon={isPublic ? ('') : <FontAwesomeIcon icon={faArrowLeft} style={{fontSize: 18}} />}
        extra={
          !newPage && !isPublic &&
          <div className={styles.headerExtra} style={{display: isExportingPage ? 'none' : 'flex'}}>
            {/* <SavingIndicator /> */}
            <Tooltip
              title={copySuccess ? <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}} />{` Copied to clipboard`}</span> : 'Share Link'}
              trigger='hover'
              placement='bottom'
              overlayClassName={styles.copyTooltip}
              onVisibleChange={visible => {
                if (!visible) {
                  setTimeout(() => {
                    setCopySuccess(false);
                  }, 300);
                }
              }}>
              <ShareButton mode='light' onClick={() => {
                shareDialog.openDialog();
              }}><FontAwesomeIcon icon={faShareNodes} style={{marginRight: 5}}/> Share
              </ShareButton>
            </Tooltip>
            <ExportButton mode='light' onClick={() => exportToGoogleDocs()}>
              {exportToDocsLoading ?
                <Spin indicator={briefAntIcon} /> :
                <FontAwesomeIcon icon={faFileArrowDown} style={{marginRight: 5}}/>}
              Export Brief
            </ExportButton>
            <div
              onMouseDown={e => {
                e.stopPropagation();
                setIsKebabOpen(!isKebabOpen);
              }}
              className={styles.kebab}
            >
              <FontAwesomeIcon icon={faEllipsisV} style={{fontSize: 14}} />
            </div>


            <div className={styles.kebabMenu} style={{display: `${isKebabOpen ? 'block' : 'none'}`}} ref={dropdownRef}>
              <ButtonComponent
                style='light-transparent'
                disabled={isExporting || isSaving}
                onClick={async () => {
                  const googledocLink = await exportToGoogledoc();
                  if (googledocLink) {
                    MixPanel.track(SCA_PAGE_EXPORT_TO_DOCS, {
                      'googleDocsLink': googledocLink,
                      'pageId': content.uuid,
                      'description': 'Page is exported to google docs',
                    });

                    window.open(googledocLink);
                  }
                }}
                className={styles.exportToDocsButton}
              >
                {isExporting ? <Spin indicator={antIcon} /> : <GoogleOutlined />} {t('open-in-google-docs')}
              </ButtonComponent>
              {/* LEFT IN CASE WE NEED IT AGAIN */}
              {/* <div className={styles.exportDropdown}>
                <Collapse ghost expandIconPosition={'right'}
                  expandIcon={({isActive}) => <CaretUpFilled rotate={isActive ? 0 : 180} />}>
                  <Collapse.Panel header='Export' key='1'>
                    <div style={{marginBottom: 5, marginTop: 5, cursor: 'pointer', fontSize: 12}}
                      onClick={e => {
                        e.preventDefault();
                        onExportEntirePage();
                      }}
                    >Export to PNG
                    </div>
                    <div>
                      <a
                        href={getXlsExportLink()}
                        style={{color: '#121212', fontSize: 12}}>
                        Export to XLS</a>
                    </div>
                  </Collapse.Panel>
                </Collapse>
              </div> */}
              {/* <div style={{margin: '0 0 5px 0', textAlign: 'left', cursor: 'pointer'}} onClick={() => exportToGoogleDocs()}>
                Export Content Brief  {exportToDocsLoading ? <Spin indicator={docsExportAntIcon} /> : null}
              </div> */}
              {/* <div style={{textAlign: 'left'}}>
                <a
                  href={getXlsExportLink()}
                  style={{color: '#121212', fontSize: 14}}>
                  Export to XLS</a>
              </div> */}
              <Button type='text' className={styles.kebabMenuItem} onClick={async () => {
                try {
                  const resp: string = await PAGES_API.exportArticleAsHtml(content.uuid);
                  const element = document.createElement('a');
                  element.setAttribute('href', 'data:text/html;charset=utf-8,' + encodeURIComponent(resp));
                  element.setAttribute('download', content.title ?? 'article');

                  element.style.display = 'none';
                  document.body.appendChild(element);

                  element.click();

                  document.body.removeChild(element);
                } catch (e) {
                  notification.error('Could not export the article.', 'Please try again.');
                }
              }}>Download as .HTML</Button>
              <Button type='text' className={styles.kebabMenuItem} onClick={() => {
                if (isWhitelabel && isAllowedPagesQuotaLimitReached) {
                  if (isGHLAccount) {
                    notification.error('', "You've reached the limit to optimize this page. Need more? Reach out to our support team for help!");
                  } else {
                    notification.error('Quota is exceeded', 'You’ve exceeded the usage limit for this tool.');
                  }
                } else if (!isAllowedPagesQuotaLimitReached) {
                  clearFeTargetKeywords();
                  clearAnalytics();
                  createPage();
                  setIsKebabOpen(false);
                } else {
                  showSidebarPaymentDrawer(null, {title: 'You need more Content Genius articles quota to continue', subtitle: '', text: `Current limit: ${quotaUtilization?.ca?.allowedPages?.total} article(s)`});
                }
              }}>{t('create-new-article')}</Button>
              <Button type='text' className={styles.kebabMenuItem} onClick={() => setIsModalOpen(true)}>{t('import-article-new-url')}</Button>
              {content.isOwner ? <Button type='text' className={classNames(styles.kebabMenuItem, styles.redText)} onClick={() => {
                deleteDialog.openDialog(router.query.uuid as string); setIsKebabOpen(false);
              }}>{t('delete-this-article')}</Button> : <Tooltip title={'This is a shared article. Only the owner can delete it.'}>
                <Button type='text' className={classNames(styles.kebabMenuItem, styles.redText)} onClick={() => {
                  return;
                }}>{t('delete-this-article')}</Button>
              </Tooltip>}
            </div>
          </div>
        }
      />
      <DeleteModal data={deleteDialog} removeFromEditorCallback={setPageRemovedFromEditor} />
      <Modal visible={isModalOpen} width={450} style={{borderRadius: '8px'}} centered className={styles.modal} onCancel={() => setIsModalOpen(false)} closable={true} footer={null}>
        <h1 className={styles.modalTitle}>{t('import-article-new-url')}</h1>
        <div className={styles.editContainer}>
          <Form initialValues={{url: ''}} form={form} onFinish={handleSubmit}>
            <Form.Item
              name='url'
              style={{marginBottom: 0}}
              rules={[
                {
                  required: true,
                  message: t('url-is-required'),
                },
                () => ({
                  validator(_, value) {
                    if (!value || isURL(value, {require_protocol: true})) {
                      return Promise.resolve();
                    }
                    // eslint-disable-next-line
                    return Promise.reject(t('url-not-valid'));
                  },
                }),
              ]}
            >
              <CommonInput className={styles.websiteInput} />
            </Form.Item>
            <Form.Item name='renderWithbrowser' valuePropName='checked'>
              <Checkbox className={styles.darkCheckbox}>Render page content with Browser</Checkbox>
            </Form.Item>
            <Form.Item>
              <Btn buttonType='primary' className={styles.btn}>{t('upload')}</Btn>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
});


const ShareButton = styled(GrayButton)`
  margin-left: auto;
  padding: 4px 17px !important;
  margin: 0 5px;
  color: #121212;
  background-color: #f9f9fb !important;
`;
const ExportButton = styled(GrayButton)`
  margin-left: auto;
  padding: 4px 17px !important;
  margin: 0 5px;
  color: #121212;
  background-color: #f9f9fb !important;
`;

